const integrationsRoute = {
	name: 'external-integrations',
	path: 'external-integrations',
	meta: {
		title: 'Integraciones Externas',
	},
	component: () => import('@/pages/configuration/page-external-integrations'),
};

export default integrationsRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/external-integrations/index.js